import React from "react";

function OverviewPanel() {
  return (
    <>
      <p>
        London council libraries house millions of books, far too many for any
        one person to read. In fact, there are some books that no one has read.
        Yet.
      </p>
      <p>
        We've asked each London council library for the books they have on their
        shelves, but which have no record of being checked out by any reader,
        ever.
      </p>
      <p>
        Together, the lists form a collection of never-loaned books – hidden
        gems scattered across London, waiting to be discovered.
      </p>
      <div className="info-panel-disclaimer">
        <strong>Note: this site does not show live availability.</strong> The
        data here was obtained via Freedom of Information requests submitted in
        the summer of 2025, and may not be reflective of the current state of a
        library's collection. Always check your local library's catalogue for
        up-to-date availability.
      </div>
      <p className="info-panel-tagline">
        <em>
          "There comes a time in every rightly-constructed boy's life when he
          has a raging desire to go somewhere and dig for hidden treasure."
        </em>
        <br />— Mark Twain, The Adventures of Tom Sawyer
      </p>
    </>
  );
}

export default OverviewPanel;
